module.exports = __webpack_public_path__ + "img/asesoramos.6e9d4436.png";